import './DisplayModel.scss';
import moment from 'moment';
import React from 'react';


const DEFAULT_DATE_FORMAT = 'LLL';


class DisplayModel extends React.Component {

  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    if (this.props.load) {
      this.load();
    } else {
      this.setState({ isLoaded: true });
    }
  }

  load() {
    // Loads a model data by classname and id.
    console.log('load.');
    this.setState({ isLoaded: false });
    setTimeout(() => this.setState({ isLoaded: true }), 400);
  }

  renderValue(value) {
    if (moment.isDate(value)) {
      return moment(value).format(DEFAULT_DATE_FORMAT);
    }
    if (Array.isArray(value)) {
      return value.map(this.renderValue.bind(this)).join(', ');
    }
    if (typeof value === typeof {}) {
      // we don't know how to display this.
      console.log('Unknown how to render object.');
      console.log(value);
      return '[Object]';
    }
    return value;
  }

  renderOptionalItem(label, value) {
    const renderedValue = this.renderValue(value);
    if (renderedValue) {
      return (
        <div className='summaryItem' key={label}>
          <div className='label'>{label}</div>
          <div className='value'>{renderedValue}</div>
        </div>
      );
    }
    return null;
  }

  render() {
    if (this.state.isLoaded) {
      const data = this.props.data;
      let labels = data.getDisplayPropertyNames();
      return (
        <div className='DisplayModel'>
          {Object.keys(labels).map(
              k => this.renderOptionalItem(labels[k], data[k]))}
        </div>
      );
    } else {
      return (
        <div className='DisplayModel loading'>
          Loading…
        </div>
      );
    }
  }
}


export default DisplayModel;
